module.exports = __webpack_public_path__ + "static/media/tests.d67f785c.svg";